export const AGREEMENT_OPTIONAL_FIELD_KEYS = [
    'TARGET_SKU_2',
    'TARGET_SKU_3',
    'NUMBER_OF_TARGET_SKU_2',
    'NUMBER_OF_TARGET_SKU_3',
    'NUMBER_OF_TARGET_SKU_2_CRATE_STACK_KEG',
    'NUMBER_OF_TARGET_SKU_3_CRATE_STACK_KEG'
];
